import { combineReducers, createSlice } from "@reduxjs/toolkit";
import { projectPixelSlice } from "./projectPixelSlice";
import { toolIntegrationsSlice } from "./toolIntegrationsSlice";
import { projectSettingsSlice } from "./projectSettingsSlice";

export default combineReducers({
    toolIntegrations: toolIntegrationsSlice.reducer,
    pixel: projectPixelSlice.reducer,
    settings: projectSettingsSlice.reducer,
})